import { render, staticRenderFns } from "./TherapyOption.vue?vue&type=template&id=4813c675"
import script from "./TherapyOption.vue?vue&type=script&lang=js"
export * from "./TherapyOption.vue?vue&type=script&lang=js"
import style0 from "./TherapyOption.vue?vue&type=style&index=0&id=4813c675&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports